import { Box, Text } from "@chakra-ui/react"

const Note = () => {
	return (
		<Box w="full">
			<Text fontSize="lg">Título</Text>
			<Text fontSize="sm" mb="2">01/01/2024 10:00:00</Text>
			<Text fontSize="md">Descrição da notaaaaaaa</Text>
		</Box>
	)
}

export default Note
